import { Link } from "@tanstack/react-router";
import { logout } from "../lib/api.js";
import { cn } from "../lib/cn.js";
import { SymbolSearch } from "./SymbolSearch.js";
import { ThemeToggle } from "./ThemeToggle.js";

const NAV = [
  { to: "/screen", label: "Screen" },
  { to: "/factor-lab", label: "Factor lab" },
  { to: "/signals", label: "Signals" },
  { to: "/trades", label: "Trades" },
  { to: "/strategy-lab", label: "Strategy lab" },
  { to: "/health", label: "Health" },
  { to: "/settings", label: "Settings" },
  // Last, after Settings: reference material, not a place a reader works.
  { to: "/docs", label: "Docs" },
] as const;

/** The frame every authenticated page sits in. */
export function AppShell({
  displayName,
  children,
}: {
  displayName: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-full flex-col">
      <nav className="flex items-center gap-4 border-b border-border px-8 py-3">
        <Link to="/" className="text-sm font-semibold">
          Savi
        </Link>
        {NAV.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            activeProps={{ className: "text-text" }}
            className={cn("text-sm text-text-muted hover:text-text")}
          >
            {entry.label}
          </Link>
        ))}
        <div className="ml-auto flex items-center gap-4">
          <SymbolSearch />
          <ThemeToggle />
          <span className="text-xs text-text-muted">{displayName}</span>
          <button
            type="button"
            onClick={() => {
              void logout().then(() => {
                window.location.href = "/login";
              });
            }}
            className="text-xs text-text-muted hover:text-text"
          >
            Sign out
          </button>
        </div>
      </nav>
      {children}
    </div>
  );
}
